"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname, useRouter } from "next/navigation";
import { i18n, Locale } from "@/i18n-config";
import { useState, useRef, useEffect } from "react";
export function LanguageSelector() {
  const $ = _c(33);
  const pathname = usePathname();
  const router = useRouter();
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);
  let t0;
  if ($[0] !== pathname) {
    t0 = locale => {
      if (!pathname) {
        return "/";
      }
      const segments = pathname.split("/");
      segments[1] = locale;
      return segments.join("/");
    };
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const redirectedPathName = t0;
  let t1;
  if ($[2] !== redirectedPathName || $[3] !== router) {
    t1 = newLocale => {
      const newPath = redirectedPathName(newLocale);
      router.push(newPath);
      setIsOpen(false);
    };
    $[2] = redirectedPathName;
    $[3] = router;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleLocaleChange = t1;
  let t2;
  if ($[5] !== pathname) {
    t2 = pathname?.split("/")[1] as Locale || i18n.defaultLocale;
    $[5] = pathname;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const currentLocale = t2;
  let t3;
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      const handleClickOutside = function handleClickOutside(event) {
        if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
          setIsOpen(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    };
    t4 = [];
    $[7] = t3;
    $[8] = t4;
  } else {
    t3 = $[7];
    t4 = $[8];
  }
  useEffect(t3, t4);
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      "pt-BR": {
        flag: "https://flagcdn.com/br.svg",
        alt: "Brasil",
        label: "PT",
        longLabel: "Portugu\xEAs"
      },
      "en-US": {
        flag: "https://flagcdn.com/us.svg",
        alt: "USA",
        label: "EN",
        longLabel: "Ingl\xEAs"
      },
      "es": {
        flag: "https://flagcdn.com/es.svg",
        alt: "Espa\xF1a",
        label: "ES",
        longLabel: "Espanhol"
      },
      "it": {
        flag: "https://flagcdn.com/it.svg",
        alt: "Italia",
        label: "IT",
        longLabel: "Italiano"
      }
    };
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const languages = t5;
  const currentLang = languages[currentLocale];
  let t6;
  if ($[10] !== isOpen) {
    t6 = () => setIsOpen(!isOpen);
    $[10] = isOpen;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = currentLang?.flag;
  const t8 = currentLang?.alt;
  let t9;
  if ($[12] !== t7 || $[13] !== t8) {
    t9 = <span className="relative flex h-5 w-5 overflow-hidden rounded-full border border-black/10"><img src={t7} alt={t8} className="h-full w-full object-cover" /></span>;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const t10 = currentLang?.label;
  let t11;
  if ($[15] !== t10) {
    t11 = <span>{t10}</span>;
    $[15] = t10;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  const t12 = `text-zinc-500 transition-transform ${isOpen ? "rotate-180" : ""}`;
  let t13;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <path d="m6 9 6 6 6-6" />;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== t12) {
    t14 = <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={t12}>{t13}</svg>;
    $[18] = t12;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== isOpen || $[21] !== t11 || $[22] !== t14 || $[23] !== t6 || $[24] !== t9) {
    t15 = <button onClick={t6} aria-expanded={isOpen} aria-haspopup="listbox" className="flex items-center gap-2 rounded-full border border-zinc-200 bg-white px-3 py-1.5 text-sm font-medium text-zinc-700 cursor-pointer transition hover:bg-zinc-50 hover:border-zinc-300">{t9}{t11}{t14}</button>;
    $[20] = isOpen;
    $[21] = t11;
    $[22] = t14;
    $[23] = t6;
    $[24] = t9;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== currentLocale || $[27] !== handleLocaleChange || $[28] !== isOpen) {
    t16 = isOpen && <div className="absolute right-0 top-full mt-2 min-w-[140px] flex flex-col overflow-hidden rounded-xl border border-zinc-100 bg-white p-1 shadow-xl ring-1 ring-black/5 z-50">{i18n.locales.map(locale_0 => {
        const langConfig = languages[locale_0 as keyof typeof languages];
        return <button key={locale_0} onClick={() => handleLocaleChange(locale_0)} className={`flex items-center gap-3 cursor-pointer rounded-lg px-3 py-2 text-sm transition hover:bg-zinc-50 ${currentLocale === locale_0 ? "bg-zinc-50 font-medium text-violet-600" : "text-zinc-700"}`}><span className="relative flex h-5 w-5 overflow-hidden rounded-full border border-black/10"><img src={langConfig.flag} alt="" className="h-full w-full object-cover" /></span>{langConfig.longLabel}</button>;
      })}</div>;
    $[26] = currentLocale;
    $[27] = handleLocaleChange;
    $[28] = isOpen;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== t15 || $[31] !== t16) {
    t17 = <div className="relative" ref={containerRef}>{t15}{t16}</div>;
    $[30] = t15;
    $[31] = t16;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  return t17;
}